import FeedUserTypes from 'common/feed-user-type';

export function isOrWasAnAthlete(feedUserRelatedId, feedUserTypeId) {
  if (feedUserTypeId !== FeedUserTypes.User) {
    return Promise.resolve(false);
  }
  return fetch(`/profile/${feedUserRelatedId}/is-or-was-athlete`, {
    credentials: 'same-origin',
    method: 'GET',
  })
    .then(response => response.json())
    .then(json => {
      return json.isOrWasAthlete;
    })
    .catch(() => {
      return false;
    });
}
